import React, { useReducer, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import isMobile from 'ismobilejs';
import moment from 'moment';

import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';

import {
  fetchGetOrders,
  fetchGetOrderById,
  fetchGetNearestOrders,
  fetchCreateOrder,
  fetchUpdateOrder,
  fetchUpdateOrderItems,
  fetchConfirmOrder,
  fetchCancelOrder,
  fetchUpdateOrderClient,
  fetchRefreshReserve,
  fetchUpdatePaymentStatus,
  fetchGetOrderHistory,
  fetchGetOrderSticker,
  fetchCopyOrder,
  fetchUpdateOrderDelivery,
  fetchUpdateOrderComment,
  fetchUpdateOrderDiscounts,
  fetchGetWorksheetFormTemplate,
} from '../../../../actions/orders';

import { fetchUpdateDeliveryResult } from '../../../../actions/delivery';
import { fetchUpdateSinglePacking, fetchSendPackingControl } from '../../../../actions/packing';
import { fetchGetPaymentMethods } from '../../../../actions/settings';
import { showModal } from '../../../../actions/modal';

import {
  parseError,
  getPaymentBagdeStyle,
  saveBase64AsPdf,
  checkIsFbm,
  getCurrencySymbol,
  getFbmType,
} from '../../../../helpers';

import { DOMAIN, MOCK_DELIVERY_ITEM } from '../../../../config';
import Adaptive from '../../../common/Adaptive';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const PaymentBadge = (currentProduct) => {
  const { checkoutSettings } = useSelector((state) => state.settings);

  const currencySymbol = currentProduct.currency
    ? getCurrencySymbol(currentProduct.currency)
    : getCurrencySymbol(checkoutSettings.currency);

  const { style, title, subtitle, icon } = getPaymentBagdeStyle(currentProduct, currencySymbol);
  const [tip, changeTip] = useState(false);

  const { t } = useAutoTranslation();

  return (
    <div
      className="payment-badge"
      style={style}
      onMouseOver={!currentProduct.mobile ? () => changeTip(true) : undefined}
      onMouseOut={!currentProduct.mobile ? () => changeTip(false) : undefined}
      onClick={currentProduct.mobile ? () => changeTip(!tip) : undefined}
    >
      {icon ? <i className={`${icon} mr-1`} /> : null}
      <div className="payment-badge-main">
        {t(title)}
        {!currentProduct.noSubtitle && subtitle ? <div>{subtitle}</div> : null}
      </div>
      {tip && currentProduct.codPayments?.length && (
        <div className="status-badge-tip">
          {currentProduct.codPayments.map((p) => (
            <div>
              Оплачен {moment(p.date).format('DD-MM-YYYY')}, <br /> платежное поручение №
              {p.paymentDocumentId}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const fixOrderItemsNumbering = (dataItems) => {
  let newItems = dataItems?.slice() ?? [];

  const findDelivery = newItems.find((i) => i.variantId === 'delivery');

  if (!findDelivery) {
    const findEmptyItemIndex = newItems.findIndex((i) => typeof i.variantId === 'undefined');
    if (findEmptyItemIndex > -1) {
      newItems[findEmptyItemIndex] = MOCK_DELIVERY_ITEM;
    } else {
      newItems.push(MOCK_DELIVERY_ITEM);
    }
  }

  return newItems
    .sort((a, b) => a.num - b.num)
    .sort((a, b) => {
      if (a.variantId === 'delivery' && b.variantId !== 'delivery') return 1;
      if (b.variantId === 'delivery' && a.variantId !== 'delivery') return -1;
      if (a.variantId === b.variantId) return 0;
    })
    .map((item, i) => ({
      ...item,
      num: i + 1,
    }));
};

const getInitialState = (props) => {
  const isNew = props.match.params.id === 'new';
  return {
    isNew,
    currentOrder: {
      needReserve: !props.defaultReserveOrders ? false : undefined,
    },
    orderId: props.match.params.id,
    nearest: null,
    orderHistory: [],
    worksheetData: null,
  };
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'updateIsNewState':
      return { ...state, isNew: action.isNew };
    case 'updateOrder':
      return { ...state, currentOrder: action.order, orderId: action.order.id };
    case 'updateNearest':
      return { ...state, nearest: action.nearest };
    case 'updateOrderHistory':
      return { ...state, orderHistory: action.orderHistory };
    case 'updateWorksheetData':
      return { ...state, worksheetData: action.worksheet };
    default:
      return state;
  }
};

const SingleOrder = (props) => {
  const checkoutSettings = useSelector((state) => state.settings.checkoutSettings);
  const defaultReserveOrders = checkoutSettings?.defaultReserveOrders;

  const [state, dispatch] = useReducer(
    reducer,
    getInitialState({ ...props, defaultReserveOrders }),
  );

  const [loadingOrder, setLoadingOrder] = useState(false);
  const [loadingClient, setLoadingClient] = useState(false);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [loadingComment, setLoadingComment] = useState(false);
  const [loadingSticker, setLoadingSticker] = useState(false);
  const [isCopy, setIsCopy] = useState(false);
  const [unsavedMaterials, setUnsavedMaterials] = useState(false);
  const [updateBatch, setUpdateBatch] = useState(false);

  const reduxDispatch = useDispatch();
  const history = useHistory();

  const authToken = useSelector((state) => state.auth.tokenData.access_token);

  const { isNew, orderId, currentOrder, nearest, orderHistory, worksheetData } = state;

  const warehouses = useSelector((state) => state.orders.warehouses);

  const findCurrentWarehouse = (array) => {
    // warehouses []
    if (warehouses) {
      if (!isNew) {
        let findResult = undefined;

        for (let i = 0; i < array.length; i++) {
          if (array[i].code === currentOrder.warehouseCode) {
            findResult = { ...array[i], parentWarehouseCode: array[i].code };
          } else if (array[i].operatorType === 'FULFILLMENT') {
            const children = array[i].children.find(
              (item) => item.code === currentOrder.warehouseCode,
            );

            if (children !== undefined) {
              findResult = {
                ...array[i],
                parentWarehouseCode: array[i].code,
                warehouseCode: children.code,
                title: children.title,
                goodsCondition: children.goodsCondition,
              };
            }
          }
        }
        return findResult;
      } else {
        const defaultWarehouse = array.find((w) => w.isDefault === true) || warehouses[0];
        const currentWarehouse = {
          ...defaultWarehouse,
          parentWarehouseCode: defaultWarehouse.code,
        };
        return currentWarehouse;
      }
    }
  };

  const currentWarehouse = findCurrentWarehouse(warehouses);
  /*  !isNew
    ? warehouses.find((w) => w.code === currentOrder.warehouseCode)
    : warehouses.find((w) => w.isDefault === true) || warehouses[0];*/

  const isManualWarehouse = currentWarehouse && currentWarehouse.operatorType === 'MANUAL';
  const stickerUrl = `https://lite.kak2c.ru/print?sToken=${authToken}&order_id=${currentOrder.id}&type=invoice_and_stiker&server=${DOMAIN}`;

  const updateNearestOrderInLeftBlock = async (orderId) => {
    dispatch({ type: 'updateNearest', nearest: null });

    const tags = history.location.state && history.location.state.tags;
    const result = await reduxDispatch(fetchGetNearestOrders(orderId, tags));

    if (result && result.length > 0) {
      dispatch({ type: 'updateNearest', nearest: result });
    }
  };

  useEffect(() => {
    (async function () {
      if (!isNew) {
        actualizeOrder(orderId);
        await updateNearestOrderInLeftBlock(orderId);
      } else {
        const result = await Promise.all([reduxDispatch(fetchGetOrders({ size: 8 }))]);
        const nearestForNewOrder = result?.[0].orders ?? null;
        dispatch({ type: 'updateNearest', nearest: nearestForNewOrder });
      }
    })();
  }, []);

  useEffect(() => {
    if (isNew && orderId !== 'new') {
      history.push(`/orders/${orderId}`);
      dispatch({ type: 'updateIsNewState', isNew: false });
      actualizeOrder(orderId);
    }
  }, [orderId]);

  const createOrder = async (data, outerRedirect) => {
    const newOrderData = Object.assign({}, data);

    if (currentWarehouse) {
      if (!newOrderData.warehouseName) newOrderData.warehouseName = currentWarehouse.title;
      if (!newOrderData.warehouseCode) newOrderData.warehouseCode = currentWarehouse.code;
    }

    newOrderData.insuranceSum = 0;
    newOrderData.insuranceSumAutoCalculation = true;

    newOrderData.packingOptions = [
      {
        packSpecialsToSeparatePackingPlace: false,
      },
    ];

    if (checkoutSettings.paymentMethods && checkoutSettings.paymentMethods.length) {
      newOrderData.paymentMethodCode = checkoutSettings.paymentMethods[0].code;
    } else {
      const paymentMethods = await reduxDispatch(fetchGetPaymentMethods());
      newOrderData.paymentMethodCode = paymentMethods[0].code;
    }
    newOrderData.paymentStatus = 'NOT_PAID';

    if (newOrderData.items) {
      newOrderData.items = fixOrderItemsNumbering(newOrderData.items);
    }

    return reduxDispatch(fetchCreateOrder(newOrderData))
      .then((res) => {
        if (!outerRedirect) {
          fireCreationRedirect(res.orderId);
        } else {
          return res;
        }
      })
      .catch(({ error, order }) => {
        error.data.errors.forEach((e) => {
          toast.error(e.message);
        });
        if (order) {
          dispatch({ type: 'updateOrder', order });
          return order;
        }
      });
  };

  const fireCreationRedirect = (orderId) => {
    window.location.href = `/orders/${orderId}`;
  };

  const actualizeOrder = async (currentId) => {
    setLoadingOrder(true);

    let order = {};
    // const tags = history.location.state && history.location.state.tags;

    const result = await Promise.allSettled([
      reduxDispatch(fetchGetOrderById(currentId)),
      reduxDispatch(fetchGetOrderHistory(currentId)),
      reduxDispatch(fetchGetWorksheetFormTemplate(currentId)),
      // reduxDispatch(fetchGetNearestOrders(currentId, tags)),
    ]).then((results) => {
      results
        .filter((r) => r.status === 'rejected')
        .forEach((r) => {
          toast.error(parseError(r.reason));
        });
      return results;
    });

    if (result[0].status === 'fulfilled') {
      order = {
        ...result[0].value,
        items: fixOrderItemsNumbering(result[0]?.value?.items),
      };
      dispatch({ type: 'updateOrder', order });
    }

    if (result[1].status === 'fulfilled') {
      dispatch({ type: 'updateOrderHistory', orderHistory: result[1].value });
    }

    if (result[2].status === 'fulfilled') {
      dispatch({ type: 'updateWorksheetData', worksheet: result[2].value });
    }

    setLoadingOrder(false);

    return order;
  };

  const actualizeOnlyOrderByIdRequest = async (currentId) => {
    let order = {};

    await reduxDispatch(fetchGetOrderById(currentId))
      .then((result) => {
        order = {
          ...result,
          items: fixOrderItemsNumbering(result?.items),
        };
        dispatch({ type: 'updateOrder', order });
      })
      .catch((error) => {
        toast.error(parseError(error.reason));
      });
  };

  const handleChangeOrder = async (order) => {
    if (order.id !== currentOrder.id) {
      await actualizeOrder(order.id);
      await updateNearestOrderInLeftBlock(order.id);
      history.push(`/orders/${order.id}`, {
        customBackLink: history.location.state?.customBackLink,
        tags: history.location.state?.tags,
      });
    }
    setUnsavedMaterials(false);
  };

  const handleEditOrder = async (newOrder) => {
    setLoadingOrder(true);
    if (isNew) {
      await createOrder(newOrder);
    } else {
      if ('rawData' in newOrder.delivery.address) {
        delete newOrder.delivery.address.rawData;
      }

      newOrder.items = fixOrderItemsNumbering(newOrder.items);

      return reduxDispatch(fetchUpdateOrder(newOrder))
        .then((result) => {
          actualizeOrder(result.id);
          return true;
        })
        .catch((error) => {
          setLoadingOrder(false);
          error.data.errors.forEach((e) => {
            toast.error(e.message);
          });
          return false;
        });
    }
  };

  const switchBatchUpdate = (bool) => setUpdateBatch(bool);

  const handleEditOrderItems = async (dataItems, additionalData = {}) => {
    setLoadingOrder(true);

    if (isNew) {
      await createOrder({ ...currentOrder, items: dataItems });
    } else {
      const newItems = fixOrderItemsNumbering(dataItems);

      const itemsToUpdate = {
        id: orderId,
        ...additionalData,
        items: newItems,
      };

      await reduxDispatch(fetchUpdateOrderItems(itemsToUpdate))
        .then((result) => {
          actualizeOrder(result.id);
          toast.info('Проверьте актуальную стоимость доставки');
        })
        .catch((error) => {
          if (error) {
            error.data.errors.forEach((e) => {
              toast.error(e.message);
            });
          }
        });
    }

    setUpdateBatch(true);

    setLoadingOrder(false);
  };

  const handleConfirmation = async () => {
    setLoadingOrder(true);
    await reduxDispatch(
      fetchConfirmOrder({
        id: orderId,
        confirmStatus: 'APPROVED',
      }),
    )
      .then((result) => {
        actualizeOrder(result.id);
      })
      .catch((error) => {
        error.data.errors.forEach((e) => {
          toast.error(e.message);
        });
      });
    setLoadingOrder(false);
  };

  const handleCancel = async () => {
    setLoadingOrder(true);
    await reduxDispatch(
      fetchCancelOrder({
        orderId,
      }),
    )
      .then(() => {
        toast.info('Заказ успешно отменен');
        if (currentOrder.status !== 'ORDER_INFO_DRAFT') {
          actualizeOrder(orderId);
        } else {
          history.push('/orders');
        }
      })
      .catch((error) => {
        error.data.errors.forEach((e) => {
          toast.error(e.message);
        });
      });
    setLoadingOrder(false);
  };

  const handleDownloadSticker = async () => {
    setLoadingSticker(true);
    await reduxDispatch(fetchGetOrderSticker(currentOrder.id))
      .then((res) => {
        saveBase64AsPdf({ ...res, fileName: `sticker-${currentOrder.id}.pdf` });
      })
      .catch((error) => {
        error.data.errors.forEach((e) => {
          toast.error(e.message);
        });
      });
    setLoadingSticker(false);
  };

  const handleUpdateDeliveryResult = async (result) => {
    setLoadingOrder(true);
    await reduxDispatch(
      fetchUpdateDeliveryResult({
        orderId,
        result,
      }),
    )
      .then(() => {
        actualizeOrder(orderId);
        toast.info('Результат доставки успешно изменен');
      })
      .catch((error) => {
        error.data.errors.forEach((e) => {
          toast.error(e.message);
        });
      });
    setLoadingOrder(false);
  };

  const handleEditClient = async (data, legalEntityData) => {
    setLoadingClient(true);
    let newOrder = null;
    if (isNew) {
      newOrder = await createOrder({ ...currentOrder, legalEntity: legalEntityData }, true);
    }
    const currentId = newOrder ? newOrder.orderId : orderId;
    return await reduxDispatch(
      fetchUpdateOrderClient({
        id: currentId,
        ...data,
      }),
    )
      .then(() => {
        if (isNew) {
          fireCreationRedirect(currentId);
        } else {
          return handleEditOrder({
            ...currentOrder,
            delivery: {
              ...currentOrder.delivery,
              receiver: {
                ...currentOrder.delivery.receiver,
                ...data,
              },
            },
            legalEntity: legalEntityData,
          });
        }
      })
      .catch((error) => {
        error.data.errors.forEach((e) => {
          toast.error(e.message);
        });
      })
      .finally(() => {
        setLoadingClient(false);
      });
  };

  const handleEditPayment = async (data) => {
    setLoadingPayment(true);
    if (currentOrder.paymentStatus !== data.paymentStatus) {
      await reduxDispatch(
        fetchUpdatePaymentStatus({
          id: orderId,
          paymentStatus: data.paymentStatus,
        }),
      ).catch((error) => {
        error.data.errors.forEach((e) => {
          toast.error(e.message);
        });
      });
    }
    await handleEditOrder({
      ...currentOrder,
      ...data,
    });
    setLoadingPayment(false);
  };

  const handleRefreshReserve = async () => {
    setLoadingOrder(true);
    await reduxDispatch(fetchRefreshReserve(orderId))
      .then((result) => {
        actualizeOrder(result.id);
      })
      .catch((error) => {
        error.data.errors.forEach((e) => {
          toast.error(e.message);
        });
      });
    setLoadingOrder(false);
  };

  const handlePacking = async () => {
    setLoadingOrder(true);
    await reduxDispatch(fetchUpdateSinglePacking({ id: orderId }))
      .then((result) => {
        toast.info('Статус заказа успешно обновлен');
        actualizeOrder(orderId);
        handleDownloadSticker();
      })
      .catch((error) => {
        error.data.errors.forEach((e) => {
          toast.error(e.message);
        });
      });
    setLoadingOrder(false);
  };

  const handleSendPackingControl = async () => {
    setLoadingOrder(true);
    await reduxDispatch(fetchSendPackingControl({ id: currentOrder.packings[0].barcode }))
      .then(() => {
        toast.info('Статус заказа успешно обновлен');
        actualizeOrder(orderId);
      })
      .catch((err) => {
        toast.error(parseError(err));
      })
      .finally(() => {
        setLoadingOrder(false);
      });
  };

  const handleCopyOrder = async () => {
    setLoadingOrder(true);
    await reduxDispatch(fetchCopyOrder(currentOrder.id))
      .then((res) => {
        toast.info('Заказ успешно скопирован');
        handleChangeOrder({ id: res.orderId });
      })
      .catch((err) => {
        toast.error(parseError(err));
      })
      .finally((res) => {
        setLoadingOrder(false);
        setIsCopy(true);
      });
  };

  const handleAddTag = (e, order) => {
    reduxDispatch(
      showModal('ChooseTags', {
        orderId: order.id,
        orderTags: order.tags,
        update: () => actualizeOrder(order.id),
      }),
    );
  };

  const handleEditDelivery = (data) => {
    const reqData = {
      id: currentOrder.id,
      ...data,
    };
    setLoadingOrder(true);
    return reduxDispatch(fetchUpdateOrderDelivery(reqData))
      .then(() => {
        actualizeOrder(currentOrder.id);
        toast.info('Данные доставки успешно изменены');
      })
      .catch((error) => {
        setLoadingOrder(false);
        toast.error(parseError(error));
      });
  };

  const handleEditDiscounts = async (data) => {
    const reqData = {
      id: currentOrder.id,
      ...data,
    };
    return reduxDispatch(fetchUpdateOrderDiscounts(reqData))
      .then(() => {
        actualizeOrder(currentOrder.id);
        toast.info('Промокод и скидка успешно добавлены');
      })
      .catch((error) => {
        toast.error(parseError(error));
      });
  };

  const handlePhoneCallBack = async (data) => {
    const reqData = {
      id: currentOrder.id,
      ...data,
    };
    return reduxDispatch(fetchConfirmOrder(reqData))
      .then(() => {
        actualizeOrder(currentOrder.id);
        toast.info('Дата и время повторного звонка успешно установлены');
      })
      .catch((error) => {
        toast.error(
          parseError(error, {
            autoClose: 15000,
          }),
        );
      });
  };

  const handleEditComment = async (data) => {
    const reqData = {
      id: currentOrder.id,
      ...data,
    };

    return await reduxDispatch(fetchUpdateOrderComment(reqData))
      .then(() => {
        actualizeOrder(currentOrder.id);
        toast.info('Комментарии успешно изменены');
      })
      .catch((error) => {
        setLoadingComment(false);
        toast.error(parseError(error));
      });
  };

  const deliveryInfo = useSelector((state) => state.orders.deliveryInfo);

  const isFbm = checkIsFbm(currentOrder?.delivery, deliveryInfo);

  const fbmType = getFbmType(currentOrder?.delivery, deliveryInfo);

  if (!isNew && !currentOrder) return null;

  const sum =
    currentOrder.items &&
    currentOrder.items.reduce((a, c) => {
      a += c.price * c.quantity;
      return a;
    }, 0);

  const haveProducts =
    currentOrder.items && currentOrder.items.filter((i) => i.variantId !== 'delivery').length;

  console.log('orderHistory', orderHistory);

  const adaptiveProps = {
    history,
    isNew,
    currentOrder,
    PaymentBadge,
    nearest: isMobile().any ? undefined : nearest,
    handleChangeOrder: isMobile().any ? undefined : handleChangeOrder,
    haveProducts,
    loadingOrder,
    currentWarehouse,
    sum,
    isManualWarehouse,
    stickerUrl,
    loadingSticker,
    worksheetData,
    handleEditOrderItems,
    handleConfirmation,
    handleRefreshReserve,
    handleCancel,
    handleUpdateDeliveryResult,
    handlePacking,
    handleSendPackingControl,
    handleDownloadSticker,
    handleCopyOrder,
    actualizeOrder,
    loadingPayment,
    handleEditPayment,
    warehouses,
    handleEditOrder,
    orderHistory,
    loadingClient,
    handleEditClient,
    loadingComment,
    handleEditComment,
    setMobileCustomMenu: isMobile().any ? props.setMobileCustomMenu : undefined,
    handleAddTag: isMobile().any ? handleAddTag : undefined,
    handleEditDelivery,
    handleEditDiscounts,
    handlePhoneCallBack,
    isFbm,
    fbmType,
    showFbmDocsUnnecessary: state.worksheetData?.requirements?.showFbmDocsUnnecessary,
    actualizeOnlyOrderByIdRequest,
    isCopy,
    setIsCopy,
    unsavedMaterials,
    setUnsavedMaterials,
    updateBatch,
    switchBatchUpdate,
  };

  return (
    <Adaptive
      DekstopComponent={DesktopLayout}
      MobileComponent={MobileLayout}
      adaptiveProps={adaptiveProps}
    />
  );
};

export default SingleOrder;
